/**
 * Created by Pavel
 */

define([
    'jQuery',
    'underscore'
], function($, _){
    'use strict';

    var instance = null;

    var StateHandler =  function() {
        this._handlers = [];
        this._paramName = 'state';
        this._state = this.getQueryState();
    };

    StateHandler.prototype = $.extend({}, {
        queryToObject: function(queryStr) {
            if (queryStr && queryStr.indexOf(this._paramName)) {
                var matches = queryStr.match(/state=[^&]+/);
                var parts;// = queryStr.split(this._paramName + '=');

                if (matches && matches.length) {
                    parts = matches[0].split('=');
                }

                return parts && parts.length > 1 ? JSON.parse(decodeURIComponent(parts[1])) : [];
            }
            return null;
        },
        objectToQuery: function(obj) {
            return obj ? this._paramName + '=' + JSON.stringify(obj) : '';
        },

        getQueryState: function() {
            return this.queryToObject(window.location.search);
        },
        /**
         * Apply state to UI
         */
        applyState: function() {
            var state = this._state;

            if (!state) {
                return;
            }
            _.each(this._handlers, function(handler) {
                var param = handler.getParam(),
                    substate = state[param];
                if (substate) {
                    handler.applyState(substate);
                }
            });
        },
        /**
         * Add handler
         * @param {type} handler
         * @returns {undefined}
         */
        addHandler: function(handler) {
            handler.init();
            this._handlers.push(handler);
        }
    });

    var getInstance = function() {
        return !instance ? (instance = new StateHandler()) : instance;
    };

    return {getInstance: getInstance};
});



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/state/stateHandler.js